import { ColumnViewModel, LegacyVisibilityModel } from '../shared/column-types';

export function buildVisibilityModel(view: ColumnViewModel): LegacyVisibilityModel {
  return Object.fromEntries(
    view.columns.map(col => [
      col,
      view.defaultVisible.includes(col),
    ]),
  );
}

export function getByViewTab(
  models: Record<string, LegacyVisibilityModel>,
  VIEW: string,
  TAB: string,
  isEvidence: boolean
): LegacyVisibilityModel | undefined {
  const viewType = isEvidence ? 'EVIDENCE' : 'SUMMARY';
  const allKeys = Object.keys(models);

  if (VIEW === 'ALL') {
    const individualTabKey = `${TAB}_ALL`;
    if (models[individualTabKey]) {
      return models[individualTabKey];
    }
  }

  const expectedKey = `${VIEW}_${TAB}_${viewType}`;
  if (models[expectedKey]) {
    return models[expectedKey];
  }

  const matchedKey = allKeys.find(key => 
    key.includes(VIEW) && 
    key.includes(TAB) && 
    key.includes(viewType)
  );

  return matchedKey ? models[matchedKey] : undefined;
}

export function getByMappingName(
  models: Record<string, LegacyVisibilityModel>,
  mappingName: string,
  isEvidence: boolean
): LegacyVisibilityModel | undefined {
  const type = isEvidence ? '_EVIDENCE' : '_SUMMARY';

  const matchedKey = Object.keys(models)
    .filter(key => key.includes(mappingName))
    .filter(key => key.includes(type))[0];

  return matchedKey ? models[matchedKey] : undefined;
}